module.exports = flarum.core.compat['components/DiscussionComposer'];